import { template as template_23c8f4ef84e84259afbcf2c3f33e4153 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { t } from 'ember-intl';
import Portal from 'ember-stargate/components/portal';
import STATION_FILTERS from 'eflex/constants/bi-andon-station-statuses';
import FilterWrapper from 'eflex/components/filters/filter-wrapper';
import SearchTag from 'eflex/components/filters/search-tag';
export default class BiPanelStationFilter extends Component {
    @service
    intl;
    @tracked
    isDisplayed = false;
    stationFilterOptions = [
        STATION_FILTERS.jem,
        STATION_FILTERS.oee
    ];
    constructor(){
        super(...arguments);
        this.isDisplayed = Boolean(this.args.stationFilter);
        this.args.initParam('stationFilter', this.args.stationFilter);
    }
    @action
    onChange(stationFilter) {
        this.args.updateParam('stationFilter', stationFilter);
    }
    get selectedStationFilter() {
        return this.args.getParam('stationFilter');
    }
    get displaySearchTag() {
        return this.args.stationFilter != null;
    }
    get selectedBadgeText() {
        const selectedFilter = this.args.stationFilter;
        if (selectedFilter == null) {
            return '';
        }
        return this.intl.t(`${selectedFilter}`);
    }
    onDisplayedChanged = ()=>{
        this.isDisplayed = !this.isDisplayed;
    };
    static{
        template_23c8f4ef84e84259afbcf2c3f33e4153(`
      <Portal @target="filter-fields">
        <FilterWrapper
            class="eflex-station-status-criteria"
            @class="align-items-end"
            @form={{@form}}
            @label="bi.andonStationFilter"
            @isDisplayed={{this.isDisplayed}}
            @onChecked={{this.onDisplayedChanged}}
            @hasValue={{this.displaySearchTag}}
            ...attributes
        >
          <div class="input-group">
            <div class="col">
              <div class="row">
                <div class="col">
                  <@form.element
                    @controlType="power-select"
                    @value={{this.selectedStationFilter}}
                    @options={{this.stationFilterOptions}}
                    @onChange={{this.onChange}}
                  as |el|>
                    <el.control
                      class="station-status-select"
                     as |opt|>
                      {{t opt}}
                    </el.control>
                  </@form.element>
                </div>
              </div>
            </div>
          </div>
        </FilterWrapper>
      </Portal>

      <Portal @target="search-badge-tags">
        <SearchTag
          class='test-station-filters'
          @isDisplayed={{this.displaySearchTag}}
          @text={{this.selectedBadgeText}}
        />
      </Portal>
    `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
